import { Link } from 'react-router-dom'
import { APP_PATH, authConfigured } from '../amplify'
import { isNativeApp } from '../lib/native'

/**
 * Entries of the app. The home page lists them, so adding a feature is one row here
 * plus a route in main.tsx; the native shell picks it up with the next build.
 */
interface Entry {
  to: string
  title: string
  description: string
  /** Show only in the native app, only on the web, or everywhere. */
  where?: 'app' | 'web'
}

const ENTRIES: Entry[] = [
  {
    to: APP_PATH,
    title: 'Race Studio',
    description: isNativeApp
      ? 'Open AIM Solo 2 session files and analyze laps, speed traces and the track map.'
      : 'Load your AIM Solo 2 session files and analyze laps, speed traces and the track map in your browser.',
  },
]

export default function Landing() {
  const entries = ENTRIES.filter((e) => !e.where || (e.where === 'app') === isNativeApp)
  return (
    <main className={`landing${isNativeApp ? ' landing-app' : ''}`}>
      <header className="landing-head">
        <div>
          <h1>Mala Racing</h1>
          <p className="tagline">Driver coaching and data analysis.</p>
        </div>
        {authConfigured && (
          <Link className="button small-button" to="/account">
            My Account
          </Link>
        )}
      </header>
      <section className="entries">
        {entries.map((e) => (
          <Link key={e.to} className="entry" to={e.to}>
            <span className="entry-title">{e.title}</span>
            <span className="entry-desc">{e.description}</span>
          </Link>
        ))}
      </section>
      <footer className="landing-foot muted small">
        <Link to="/privacy">Privacy policy</Link> · <Link to="/support">Support</Link>
      </footer>
    </main>
  )
}
